module.exports = __webpack_public_path__ + "static/media/carta_13.fea916f5.jpg";